import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const VehicleSegmentAnalysisPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Vehicle Segment Analysis
      </PageTitle>
      <GenericReport reportId={10} />
    </>
  );
};

export default VehicleSegmentAnalysisPage;
